// frontend/src/components/LoggedOutPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TokenStorage } from '../utils/api';

export default function LoggedOutPage() {
  useEffect(() => {
    console.log('LoggedOutPage.JSX - Logging out, removing access token');
      TokenStorage.removeToken();
  }, []);

  const navigate = useNavigate();

  const goToLogin = () => {
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4 sm:p-6">
      <div className="bg-white rounded-xl shadow-md p-6 sm:p-10 max-w-[400px] w-full text-center">
        <img
          src="/STB_LOGO_V1.png"
          alt="Secure the Bag"
          className="w-20 h-20 mx-auto mb-6"
        />
        <h1 className="text-2xl sm:text-2xl font-semibold mb-3" style={{ color: '#2b5f78' }}>
          You've been logged out
        </h1>
        <p className="text-base text-gray-500 mb-8">
          Thanks for using Secure the Bag. See you next time!
        </p>
        <button
          onClick={goToLogin}
          className="w-full min-h-[44px] px-6 py-3 text-base font-medium text-white rounded-lg cursor-pointer transition-colors duration-200 hover:opacity-90"
          style={{ backgroundColor: '#2b5f78' }}
        >
          Return to Login
        </button>
      </div>
    </div>
  );
}
